import { render, staticRenderFns } from "./OrganisationCreation.vue?vue&type=template&id=698cb059&scoped=true"
import script from "./OrganisationCreation.vue?vue&type=script&lang=js"
export * from "./OrganisationCreation.vue?vue&type=script&lang=js"
import style0 from "./OrganisationCreation.vue?vue&type=style&index=0&id=698cb059&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698cb059",
  null
  
)

export default component.exports